import React from 'react';
import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';


class ResultModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: props.showModal,
            animation: false,
            centered: true
        };

        this.handleNextQuestion = this.handleNextQuestion.bind(this);
        this.handleTryAgain = this.handleTryAgain.bind(this);
    }

    handleTryAgain() {
        this.props.tryAgain();
    }

    handleNextQuestion() {
        this.setState({
            showModal: false
        });
        this.props.showNextQuestion();

    }

    render() {
        return (
            <Modal className={`${this.props.isAnswerCorrect ? 'correct' : 'incorrect'} result-modal `}
                   centered={this.state.centered} show={this.props.showModal} animation={this.state.animation}>
                <Modal.Header>
                    <Modal.Title>
                        <div className="header-container">
                            <span id="score">{`Score: ${this.props.correctAnswers}/${this.props.questionsShown}`}</span>
                            {this.props.question.sourceUrl && this.props.question.sourceUrl.length > 1 && (
                                <a className={`btn btn-warning`} href={this.props.question.sourceUrl}
                                   target="_blank"
                                   rel="noopener noreferrer">Source</a>
                            )}
                        </div>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <span
                        id={`question-answer-result-text`}>{this.props.isAnswerCorrect ? 'Correct!' : 'Incorrect!'}</span>
                    <br/>
                </Modal.Body>

                <Modal.Footer>

                    {!this.props.isAnswerCorrect &&
                    <Button variant="success" onClick={this.handleTryAgain}>Try Again</Button>
                    }
                    {this.props.isAnswerCorrect &&
                    <Button variant="primary" onClick={this.handleNextQuestion}>Next Question</Button>
                    }
                </Modal.Footer>
            </Modal>
        );

    }
}

export default ResultModal;
